import type { FullShipment } from '@fv/client-types'

import { DetailPanelLayout } from './DetailPanelLayout'
import {
  MessagesNotesTagsContent,
  MessagesNotesTagsNav,
  useMessagesNotesTagsState,
} from './MessagesNotesTagsControls'

type MessagesNotesTagsPanelProps = {
  closePanel?: () => void
  load: FullShipment
}

const MessagesNotesTagsPanel = ({
  closePanel,
  load,
}: MessagesNotesTagsPanelProps) => {
  const state = useMessagesNotesTagsState()

  return (
    <DetailPanelLayout
      header={<MessagesNotesTagsNav closePanel={closePanel} {...state} />}
    >
      <MessagesNotesTagsContent load={load} {...state} />
    </DetailPanelLayout>
  )
}
export default MessagesNotesTagsPanel
